import { CSSProperties } from 'react';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** marginRight (35/36) + the bespoke 26/24px gap have no DS token */
const getLabelsRowStyle = (isNewDesign?: boolean, rightOffset?: number): CSSProperties => ({
  marginRight: rightOffset ?? (isNewDesign ? 35 : 36),
  gap: isNewDesign ? 26 : 24,
});
/** fixed 50px column width (new design) keeps labels aligned with the action buttons below */
const actionLabelStyle: CSSProperties = { width: 50 };

interface ICardActionsHeaderProps {
  actions?: string[];
  isNewDesign?: boolean;
  rightOffset?: number;
}

export const CardActionsHeader = ({
  actions = [],
  isNewDesign,
  rightOffset,
}: ICardActionsHeaderProps) => (
  <Row justify="end" align="center" width={isNewDesign ? '100%' : '700px'}>
    <Row style={getLabelsRowStyle(isNewDesign, rightOffset)}>
      {actions.map((action) => (
        <Typography
          key={action}
          as="span"
          bold
          size="body_large"
          color={colors.primary['500']}
          textAlign={isNewDesign ? 'center' : undefined}
          style={isNewDesign ? actionLabelStyle : undefined}
        >
          {action}
        </Typography>
      ))}
    </Row>
  </Row>
);
